import { type DepositFeeSummaryData, type DiscountsSectionData } from "./types";

/** Ensures a price is displayed as negative, avoiding -0 when value is 0. */
export const negatePrice = (value: number): number =>
  value === 0 ? 0 : -Math.abs(value);

/** Whether the Discounts section has anything to show. */
export const hasDiscounts = (data: DiscountsSectionData): boolean =>
  data.items.length > 0 || data.total !== 0;

/** Whether the Deposit Fee section has anything to show. */
export const hasDepositFees = (data: DepositFeeSummaryData): boolean =>
  data.rows.length > 0;
